import './Footer.scss';
import React from 'react';
import footerLogo from '../../assets/img/logoFooter.svg';
import facebookLink from '../../assets/img/facebook-link.svg';
import instagramLink from '../../assets/img/instagram-link.svg';
import youtubeLink from '../../assets/img/youtube-link.svg';
import linkedinLink from '../../assets/img/linkedin-link.svg';
import telegramLink from '../../assets/img/telegram-link.svg';
import { Link,useMatch } from 'react-router-dom';
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop';
import { whitelists } from '../../i18n';


const footerLinksData = [
  {
    logoImg: facebookLink,
    link: 'https://www.facebook.com/weexpert.io'
  },
  {
    logoImg: instagramLink,
    link: 'https://instagram.com/weexpert.io'
  },
  {
    logoImg: youtubeLink,
    link: 'https://youtube.com/@weexpert_pl'
  },
  {
    logoImg: linkedinLink,
    link: 'https://www.linkedin.com/company/biznesexpert/'
  },
  {
    logoImg: telegramLink,
    link: 'https://t.me/Biznesexpert_bot'
  },
]
const footerLink = footerLinksData.map((item, index) => (
  <div key={index}><a href={item.link} target='blank' ><img src={item.logoImg} alt="link img" /></a></div>
));


const footerAdress = ['ul. Kuźnicza 10, floor 5', '50-138 Wroclaw, Poland', 'NIP: 9671458021',<a href="tel:+48 718 808 505" className="binct-phone-number-1">+48 718 808 505</a>,  <a href="mailto:info@weexpert.io">info@weexpert.io</a>];
const footerAdressItem = footerAdress.map((item, index) => (
  <div className="adress-text" key={index}>{item}</div>
));

function Footer({ t }) {
  const match = useMatch('/:lang/*');

  let lang = match && match.params ?
    (whitelists.includes(match.params.lang) ? match.params.lang : null) :
    null;
    const freelanceLink = lang ? `/${lang}` : '/';
    const aboutLink = lang ? `/${lang}/about` : '/about/';
    const faqLink = lang ? `/${lang}/faq` : '/faq/';
    const contactsLink = lang ? `/${lang}/contacts` : '/contacts/';
  

  const footerNav = [
  { description: t("footer_link_about"), link: `${aboutLink}` },
  { description: t("footer_link_faq"), link: `${faqLink}` },
  { description: t("footer_link_contact_us"), link: `${contactsLink}` },];
  const footerNavItem = footerNav.map((item, index) => (
    <div className="link-item" key={index} ><Link to={ item.link}>{item.description}</Link></div>
  ));

  return (
    <div className="footer-wrapper">
      <div className="footer-content-wrapper">
        <div className="footer-content">
          <div className="footer-links">
            <div className="footer-logo">
            <Link className={`${"nav-link"}`} to={freelanceLink} ><img src={footerLogo} alt="footer logo" /></Link>
            </div>
            <div className="footer-links-wrapper">
              {footerLink}
            </div>
          </div>
          <div className="footer-nav">
            {footerNavItem}
            <div className="link-item">
              <Link to="/Privacy" target="_blank">{t("footer_link_privacy")}</Link>
            </div>
          </div>
          <div className="footer-adress">
            {footerAdressItem}
          </div>
        </div>
        <div className="footer-bottom">
          <div>Copyright © 2023 Biznes Expert Sp. z o. o.</div>
          <div>{t("footer_bottom_description")}</div>
        </div>
      </div>
      <ScrollToTop />
    </div>
  );
}

export default Footer;